import { types, flow } from 'mobx-state-tree';
import axios from 'server';

export const OdicStore = types
  .model('OdicStore', {
    credentials: types.maybeNull(types.frozen()),
    isLoading: types.optional(types.boolean, false),
    error: types.maybeNull(types.string),
  })
  .views((self) => ({
    get existingRedirectUris() {
      return self.credentials?.data?.[0]?.redirect_uris || [];
    },
    get clientId() {
      return self.credentials?.data?.[0]?.client_id;
    },
  }))
  .actions((self) => {
    return {
      fetchCredentials: flow(function* () {
        self.isLoading = true;
        self.error = null;
        try {
          const response = yield axios.get(`/oauth/all-credentials?type=oidc&provider=google`);
          self.credentials = response.data;
        } catch (error: any) {
          console.error('Error fetching OIDC credentials:', error);
          self.error = error.message;
        } finally {
          self.isLoading = false;
        }
      }),

      saveRedirectUri: flow(function* (newRedirectUri: string) {
        try {
          const existingUris = self.existingRedirectUris;
          const updatedUris = [...existingUris, newRedirectUri];
          const payload = {
            client_id: self.clientId,
            redirect_uris: updatedUris,
            type: 'oidc',
          };
          const response = yield axios.put(`/oauth/redirect-uri`, payload);
          return response.data;
        } catch (error: any) {
          console.error('Error saving redirect URI:', error);
          self.error = error.message;
          throw error;
        }
      }),

      deleteRedirectUri: flow(function* (uriToDelete: string) {
        try {
          const payload = {
            client_id: self.clientId,
            redirect_uris: [uriToDelete],
          };
          const response = yield axios.delete(`/oauth/redirect-uri`, { data: payload });
          return response.data;
        } catch (error: any) {
          console.error('Error deleting redirect URI:', error);
          self.error = error.message;
          throw error;
        }
      }),
    };
  })
  .actions((self) => ({
    refreshAfterSave: flow(function* (newRedirectUri: string) {
      yield self.saveRedirectUri(newRedirectUri);
      yield self.fetchCredentials();
    }),

    refreshAfterDelete: flow(function* (uriToDelete: string) {
      yield self.deleteRedirectUri(uriToDelete);
      yield self.fetchCredentials();
    }),
  }));
